
import config from "../config";
export class EnvironmentService {
    public static getRootUrl(){
        return config.rootUrl;
    }
}